"use client"

import type React from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"
import { ApiClientError } from "@/lib/api/client"

export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => createReactQueryClient())

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export function createReactQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Don't retry 4xx client errors — only 5xx/network/timeout
          if (error instanceof ApiClientError && typeof error.status === 'number') {
            const status = error.status
            if (status >= 400 && status < 500) return false
          }
          return failureCount < 2
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
    },
  })
}

